import { Label, LabelJSON } from './Label';

export interface HCLTreeVertexValueJSON {
  label: LabelJSON;
}

abstract class HCLTreeVertexValue {
  protected label: Label;

  /**
   * @param {Label} label
   */
  protected constructor(label?: Label) {
    this.label = label || this.getDefaultLabel();
  }

  /**
   * @return {Label}
   */
  getLabel(): Label {
    return this.label;
  }

  public getDefaultLabel(): Label {
    return new Label('Abstract HCL Vertex', '');
  }

  /**
   * @param {Label} label
   */
  setLabel(label: Label) {
    this.label = label;
  }

  public getFormattedSubLabel(): string {
    return '';
  }

  /**
   * @return {Object<String, *>} - dictionary object that describes this
   */
  toJSON(): HCLTreeVertexValueJSON {
    return { label: this.label.toJSON() };
  }

  abstract clone(): HCLTreeVertexValue;
}

export default HCLTreeVertexValue;
